import { Button, Result } from "antd";
import { useTranslation } from "react-i18next";

import { NAMESPACES } from "@/constants/i18next.constants";

function ErrorElement() {
  const { t } = useTranslation([NAMESPACES.COMPONENTS]);

  const handleOnClick = () => {
    location.reload();
  };

  return (
    <Result
      status="error"
      title={t("anErrorOccurred", {
        ns: NAMESPACES.VALIDATION,
      })}
      subTitle={t("errorElement.message")}
      extra={[
        <Button type="primary" onClick={handleOnClick} variant="solid" color="default" size="small">
          {t("errorElement.buttonText")}
        </Button>,
      ]}
    />
  );
}

export default ErrorElement;
